import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  agentActionSchema,
  agentStatusSchema,
  agentConfigSchema,
  agentMetricsSchema,
  agenticSystemStatusSchema,
  agentTypeEnum,
} from '../schemas/agents.schemas';
import { errorResponseSchema, paginationQuerySchema } from '../schemas/common.schemas';

const c = initContract();

export const agentsContract = c.router({
  getSystemStatus: {
    method: 'GET',
    path: '/agents/status',
    responses: {
      200: agenticSystemStatusSchema,
      401: errorResponseSchema,
    },
    summary: 'Get live agentic system status',
  },
  getAgentStatus: {
    method: 'GET',
    path: '/agents/:agentType/status',
    pathParams: z.object({
      agentType: agentTypeEnum,
    }),
    responses: {
      200: agentStatusSchema,
      404: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Get status for a specific agent',
  },
  getAgentMetrics: {
    method: 'GET',
    path: '/agents/:agentType/metrics',
    pathParams: z.object({
      agentType: agentTypeEnum,
    }),
    query: z.object({
      from: z.coerce.date(),
      to: z.coerce.date(),
    }),
    responses: {
      200: agentMetricsSchema,
      404: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Get performance metrics for an agent',
  },
  getAgentConfig: {
    method: 'GET',
    path: '/agents/:agentType/config',
    pathParams: z.object({
      agentType: agentTypeEnum,
    }),
    responses: {
      200: agentConfigSchema,
      404: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Get agent configuration',
  },
  updateAgentConfig: {
    method: 'PATCH',
    path: '/agents/:agentType/config',
    pathParams: z.object({
      agentType: agentTypeEnum,
    }),
    body: agentConfigSchema.partial(),
    responses: {
      200: agentConfigSchema,
      404: errorResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Update agent configuration',
  },
  listAgentActions: {
    method: 'GET',
    path: '/agents/actions',
    query: paginationQuerySchema.merge(
      z.object({
        conversationId: z.string().uuid().optional(),
        agentType: agentTypeEnum.optional(),
        status: z.enum(['pending', 'in_progress', 'completed', 'failed']).optional(),
      }),
    ),
    responses: {
      200: z.object({
        actions: z.array(agentActionSchema),
        pagination: z.object({
          page: z.number(),
          limit: z.number(),
          total: z.number(),
          totalPages: z.number(),
        }),
      }),
      401: errorResponseSchema,
    },
    summary: 'List agent actions with filters',
  },
});
